import React, { Component } from 'react';
import { connect } from 'react-redux';

import i18n from 'app/common/i18n';
import StyleSheet from 'stilr';

import { seekers as getSeekers } from 'app/redux/modules/seekers';
import { activeDwellings as getActives } from 'app/redux/modules/dwellings';
import Loading from 'app/common/Loading';

import ListItem from './list-item';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  MenuItem,
  TextField
} from '@mui/material';

import { setTitle } from 'app/layout/redux';
import TextInputWithButton from './adminInput';

function isAdmin(user) {
  try {
    return (user && user.get('role') === 'admin') || false;
  } catch (e) {
    if (__DEV__) {
      console.error(e);
    }
  }
  return false;
}

const styles = StyleSheet.create({
  label: {
    display: 'inline-block',
    marginRight: '6px',
    fontSize: '10px',
    background: 'rgb(224, 224, 224)',
    borderRadius: '8px',
    padding: '0 10px',
    lineHeight: '20px',
    verticalAlign: 'top',
    textTransform: 'capitalize'
  },
  blur: {
    color: 'transparent !important',
    textShadow: '0 0 5px rgba(0,0,0,0.4)'
  }
});

function sortBy(key, asc) {
  const returnValues = asc ? [1, -1] : [-1, 1];
  return (a, b) =>
    a[key] || 0 > b[key] || 0
      ? returnValues[0]
      : a[key] || 0 < b[key]
      ? returnValues[1]
      : 0;
}

@connect(
  ({ seekers, dwellings, auth: { user } }) => ({
    dwellings,
    user,
    seekers
  }),
  {
    setTitle,
    getSeekers,
    getActives
  }
)
@i18n
class Boligsoegerlisten extends Component {
  constructor(props) {
    super(props);
    this.state = null;
  }

  componentDidMount() {
    this.props
      .getActives()
      .then((res) => this.setState({ actives: res?.payload || [] }));
    this.props.setTitle(this.props.i18n('Boligsøgerlisten'));
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.seekers !== nextProps.seekers) {
      this.setState({
        data: nextProps.seekers.data,
        isAsc: false
      });
    }
  }

  componentWillUnmount() {
    this.props.setTitle();
  }

  render() {
    const { disabled, style = {}, user } = this.props;
    const cellClassName = [disabled && styles.blur].filter(Boolean).join(' ');
    const admin = isAdmin(user);

    const handleSort = (value) => {
      const data = this.state?.data;
      if (!data || !value) {
        return;
      }

      const key = value;
      this.setState({
        data: data.sort(sortBy(key, this.state?.isAsc)),
        isAsc: !this.state?.isAsc
      });
    };

    const makeTableCell = (value, title) => {
      return (
        <TableCell
          key={value}
          onClick={() => handleSort(value)}
          value={value}
          style={{ textAlign: 'center' }}
        >
          {this.props.i18n(title)}
        </TableCell>
      );
    };

    const handleChange = (event) => {
      const { user } = this.props;
      const uuid = event.target.value;
      this.setState({ loading: true });
      this.props
        .getSeekers({
          id: uuid,
          option: 'Dwelling',
          externalFrom: user.get?.('id')
        })
        .then((res) =>
          this.setState({
            data: res?.payload?.result || [],
            loading: false,
            uuid
          })
        )
        .catch(() => this.setState({ loading: false }));
    };

    const onClick = (text, option) => {
      this.setState({ loading: true });
      this.props
        .getSeekers({
          id: text,
          option: option,
          externalFrom: user.id || user.get?.('id')
        })
        .then((res) =>
          this.setState({
            data: res?.payload?.result || [],
            loading: false,
            uuid: text
          })
        )
        .catch(() => this.setState({ loading: false }));
    };

    return (
      <div style={{ overflowX: 'auto' }}>
        {admin ? (
          <TextInputWithButton
            onClick={onClick}
            options={['Dwelling', 'User']}
            placeholder={this.props.i18n('Enter ID')}
            label={this.props.i18n('Lookup')}
          />
        ) : this.state?.actives?.length ? (
          <TextField
            id="select"
            label={this.props.i18n('Address')}
            select
            fullWidth
            onChange={handleChange}
          >
            {this.state.actives.map((active) => {
              return (
                <MenuItem key={active.uuid} value={active.uuid}>
                  {active.location.address}
                </MenuItem>
              );
            })}
          </TextField>
        ) : this.state?.loading ? (
          <Loading />
        ) : !this.state?.actives?.length ? (
          <div style={{ padding: '22px', textAlign: 'center' }}>
            <i>{this.props.i18n('No active dwellings')}</i>
          </div>
        ) : null}
        <Table style={{ ...style, tableLayout: 'auto', minWidth: 700 }}>
          <TableHead>
            <TableRow>
              {[
                ['name', this.props.i18n('Name')],
                ['email', this.props.i18n('Email')],
                ['activeSince', this.props.i18n('Active Since')],
                ['options', this.props.i18n('Options')]
              ].map((header) => makeTableCell(header[0], header[1]))}
            </TableRow>
          </TableHead>
          {this.state?.data?.length ? (
            <TableBody style={{ tableLayout: 'auto' }}>
              {this.state?.data.slice(0, 10).map((item, idx) => (
                <ListItem
                  key={item._id || idx}
                  item={item}
                  cellClassName={cellClassName}
                  admin={admin}
                  user={user}
                  uuid={this.state?.uuid}
                />
              ))}
            </TableBody>
          ) : null}
        </Table>
        {this.state?.loading ? (
          <Loading />
        ) : !this.state?.data?.length ? (
          <div style={{ padding: '22px', textAlign: 'center' }}>
            <i>{this.props.i18n('No seekers available')}</i>
          </div>
        ) : null}
      </div>
    );
  }
}

export default Boligsoegerlisten;